<div *ngIf="paginacaoRevisoes" class="ui-grid-row mt-2">
    <h3>{{'AVISOS.REVISAO_SELO.TITLE' | translate }}</h3>
    <p-table
        [value]="paginacaoRevisoes.conteudo"
        [paginator]="true"
        [rows]="paginacaoRevisoes.tamanhoPagina"
        [totalRecords]="paginacaoRevisoes.totalItens"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        [loading]="loading"
        [resizableColumns]="true"
        (onLazyLoad)="loadLazy($event)">
        <ng-template pTemplate="header">
            <tr>

                <th style="text-align: start" class="col-data">{{'AVISOS.REVISAO_SELO.LABEL.DATA_PEDIDO_REVISAO' | translate }}</th>
                <th style="text-align: start" class="col-prazo">{{'AVISOS.REVISAO_SELO.LABEL.PRAZO_REVISAO' | translate }}</th>
                <th style="text-align: start">{{'AVISOS.REVISAO_SELO.LABEL.REVISAO_SOLICIADA' | translate }}</th>

                <th style="text-align: start"> {{'AVISOS.REVISAO_SELO.LABEL.N_SOLICITACAO' | translate }}</th>
                <th style="text-align: center" class="col-data">{{'AVISOS.REVISAO_SELO.LABEL.DATA_ANALISE' | translate }}</th>
                <th style="text-align: start"> {{'AVISOS.REVISAO_SELO.LABEL.PRODUTO' | translate }}</th>
                <th style="text-align: start"> {{'AVISOS.REVISAO_SELO.LABEL.DENOMINACAO_VENDA' | translate }}</th>
                <th style="text-align: center" class="col-codigo">{{'AVISOS.REVISAO_SELO.LABEL.CD_SELO_ARTE' | translate }}</th>
                <th style="text-align: center" class="col-codigo">{{'AVISOS.REVISAO_SELO.LABEL.CD_SELO_QUEIJO' | translate }}</th>
                <th class="col-acao" >{{'AVISOS.REVISAO_SELO.LABEL.ACAO' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index="rowIndex">
            <tr>
                <td class="">{{item.dataSolicitacao | date: 'dd/MM/yyyy'}}</td>
                <td class="">{{item.prazoParaRevisar}}</td>
                <td class="">{{item.revisaoSolicitada}}</td>

                <td class="">{{item.solicitacao.nrSolicitacao}}</td>
                <td class="">{{item.solicitacao.dataAnalise | date: 'dd/MM/yyyy'}}</td>
                <td class="">{{item.solicitacao.produtoSisbi?.produtoSif?.nmProdutoPadronizado}}</td>
                <td class="">{{item.solicitacao.produtoSisbi?.nmVenda}}</td>
                <td class="">{{item.solicitacao.cdSeloArte}}</td>
                <td class="">{{item.solicitacao.cdSeloQueijo}}</td>
                <td>
                    <div *ngIf="podeAnalisarRevisao(item)">
                        <a  (click)="revisarSelo(item)">{{'AVISOS.REVISAO_SELO.LABEL.REVISAR_SELO' | translate }}</a>
                    </div>
                    <div *ngIf="!podeAnalisarRevisao(item)">
                        <a (click)="visualizar(item)">{{'AVISOS.REVISAO_SELO.LABEL.VISUALIZAR_REVISAO_SELO' | translate }}</a>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            Registros página atual: {{paginacaoRevisoes.totalItensPaginaAtual}} | Registros total: {{paginacaoRevisoes.totalItens}}
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="10">
                    <app-empty-table [data]="paginacaoRevisoes.conteudo" [message]="'COMUM.LABEL.LISTA_VAZIA' | translate"></app-empty-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
